<template>
  <v-row>
    <v-col>
      <v-card height="100%" variant="outlined" class="bg-white pa-3">
        <v-card-title class="align-center">
          <v-icon color="primary" class="mr-2">far fa-ticket</v-icon>
          License Details
        </v-card-title>
        <v-card-text class="pa-3">
          <v-row>
            <v-col cols="6">
              <detail-row
                :label="$t('accessCode.code')"
                data-pw="voucherDetailCode"
              >
                <template #value>
                  <div class="bg-blue-grey-darken-1 rounded pa-1 d-inline">
                    {{ accessCode.code }}
                  </div>
                </template>
              </detail-row>
              <detail-row
                label="Created At"
                :value="toLocaleDateTime(accessCode.createdAt)"
                data-pw="voucherDetailUsedAt"
              />
              <detail-row
                :label="$t('accessCode.used_at')"
                :value="toLocaleDateTime(accessCode.usedAt)"
                data-pw="voucherDetailUsedAt"
              />
            </v-col>
            <v-col cols="6">

              <detail-row
                :label="$t('accessCode.account_type')"
                data-pw="voucherDetailAccountType"
              >
                <template #value>
                  <v-account-type-chip :account-type="accessCode.accountType" />
                </template>
              </detail-row>

              <detail-row
                :label="$t('accessCode.research')"
                :value="accessCode.researchAssessments.length > 0 ? 'Yes' : 'No'"
                data-pw="voucherDetailResearchAssessments"
              />

              <detail-row
                :label="$t('accessCode.research_assessments')"
                :value="formattedResearchAssessments"
                data-pw="voucherDetailResearchAssessments"
              />
            </v-col>
          </v-row>

        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script setup lang="ts">
import {computed} from "vue";
import {AccessCode} from "@YenzaCT/sdk";
import DetailRow from "@/components/DetailRow.vue";
import {toLocaleDateTime} from "@/lib/time";
import {useI18n} from "vue-i18n";
import VAccountTypeChip from "@/components/VAccountTypeChip.vue";

const {t} = useI18n();

const props = defineProps<{
  accessCode: AccessCode;

}>();

const hasResearchAssessments = computed(() =>
  Object.keys(props.accessCode.researchAssessments || {}).length > 0);

const formattedResearchAssessments = computed(() => {
  if (!hasResearchAssessments.value) return null;

  return props.accessCode.researchAssessments
    .map((assessmentKey) => t(`assessments.${assessmentKey}.title`))
    .join(", ");
});
</script>
